// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1249":"45fff0120aeaee87","6668":"411e3501fd893dd5","7361":"fcfdd5ae8aaa1af1","8433":"03ca38cbfc9ca19c"}[chunkId] + ".js";
};